export default __webpack_public_path__ + "static/media/dots-black.626cafc9.svg";